import React from 'react';
import {renderToString} from 'react-dom/server';

import RankingTile from '@Themes/natucare/modules/Article/components/RankingTile/RankingTile';
import RankingTileNew from '@Themes/natucare/modules/Article/components/RankingTileNew/RankingTileNew';

import * as styles from '@/templates/Blog/templates/BlogPost/BlogPost.module.scss';

const replaceProductIDs = (items, match, id1, id2) => {
  let html = '';
  const id = id1 || id2;
  const item = items[id];

  if (!item || typeof item === 'undefined') {
    return html;
  }

  const isHiddenProduct = item?.options?.indexOf('hide-product') > -1;
  
  const data = {
    label: item?.badge,
    heading: item?.productName,
    description: item?.description,
    picture: {
      src: item?.image,
      alt: item?.productName
    },
    buttons: item.buttons,
    score: item.rating,
    scoreText: item.ratingLabel,
    accordion: item.accordions,
    classname: `${styles.rankingTile} rankingProductTitle`,
    id: isHiddenProduct ? 'alternative' : null,
    style: isHiddenProduct ? {display: 'none'} : null
  };

  // if (item?.variant === 'v1' || item?.variant === 'v2') {
    // html = renderToString(<RankingTileNew {...data} buttonHeading="ZOBACZ CENĘ" descriptionHeading="Szczegóły produktu" variant={item.variant} />);
  // } else {
    // html = renderToString(<RankingTile {...data} />);
    html = renderToString(<RankingTileNew {...data} buttonHeading="ZOBACZ CENĘ" descriptionHeading="Szczegóły produktu" variant='v1' />);
  // }

  // Replace the matched string with the product type
  return html;
};

export default replaceProductIDs;
